/**
 * Whether an oRPC error is a request the browser cancelled, not a failure.
 *
 * Three shapes, because the SDK has produced all three:
 *   1. A raw `AbortError` from `fetch`.
 *   2. The abort phrasing in the message itself (older SDK behaviour).
 *   3. oRPC wrapping the abort as "Cannot parse response body…" with the real
 *      `AbortError` on `cause` — the common production shape. Without the
 *      cause check every navigation-cancelled request logged as an error.
 */
export function isAbortedRequest(error) {
    const err = error;
    const message = err.message ?? "";
    const causeMessage = err.cause?.message ?? "";
    return (err.name === "AbortError" ||
        err.cause?.name === "AbortError" ||
        message.includes("signal is aborted") ||
        message.includes("stream closed") ||
        message.includes("aborted a request") ||
        causeMessage.includes("aborted a request") ||
        causeMessage.includes("signal is aborted"));
}
//# sourceMappingURL=orpc_errors.js.map